import { render, staticRenderFns } from "./EditToggle.vue?vue&type=template&id=1247190a&lang=html&"
import script from "./EditToggle.vue?vue&type=script&lang=js&"
export * from "./EditToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports